import * as SVG from '@Utils/Svgs';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAuth } from '@Bootstraps/bootstrapActions';
import JWTDecode from 'jwt-decode';
import '@Styles/components.css';
import { useMemo } from 'react';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { cart, accessToken } = useSelector(state => state);
  const user = useMemo(() => {
    if (accessToken) {
      return JWTDecode(accessToken).user;
    }
  }, [accessToken]);
  // const user = useSelector(state => state).users.filter(user => user.accessToken === auth)[0];

  const navs = [
    {
      title: 'Home',
      path: '/',
    },
    {
      title: 'Clothes',
      path: '/clothes',
    },
    {
      title: 'Categories',
      path: '/categories',
    },
    // {
    //   title: "Cloth",
    //   path: "/clothes/cloth"
    // },
    {
      title: 'About',
      path: '/about',
    },
  ];

  return (
    <nav className="navbar navbar-expand-lg pt-4">
      <div className="container">
        <a className="navbar-brand" href="/">
          <h2 className="fw-bold mt-2">
            B <span>H</span>
            <span className="rotate">EV</span>I N
          </h2>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav mx-auto">
            {navs.map((el, id) => {
              return (
                <div key={id} onClick={() => navigate(el.path)} className={`nav-link cursor-pointer fw-semibold ms-lg-5 ${location.pathname === el.path ? 'active' : ''}`}>
                  {el.title}
                </div>
              );
            })}
          </div>
          <div className="d-none d-lg-flex align-items-center">
            <div className="position-relative cursor-pointer" onClick={() => navigate("/profile?cart")}>
              <img src={SVG.CART} alt="cart" width="24" />
              <div className="fill">{cart.length}</div>
            </div>
            {accessToken ? (
              <div className="d-flex align-items-center cursor-pointer ms-5" onClick={() => navigate("/profile")}>
                <div className="avatar rounded-circle" style={{ backgroundImage: `url(${user?.avatar})` }} />
                <p className="m-0 ms-3 fw-semibold m-0">{user?.username}</p>
              </div>
            ) : (
              <div className="ms-5">
                <img src={SVG.USER} alt="cart" width="26" className="cursor-pointer" onClick={() => navigate('/login')} />
              </div>
            )}
          </div>
          {accessToken ? (
            <button className="btn btn-login w-100 d-block d-lg-none mt-3" onClick={() => navigate("/profile")}>
              <i className="fa-solid fa-user me-2"></i>
              Profile
            </button>
          ) : (
            <button className="btn btn-login w-100 d-block d-lg-none mt-3" onClick={() => navigate('/login')}>
              <i className="fa-solid fa-user me-2"></i>
              Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;